import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "member_expert_m_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  key: 0,
  class: "saixuan"
};
const _hoisted_4 = {
  key: 1,
  class: "tjList"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "upList"
};
const _hoisted_7 = {
  class: "touxiang"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "item_info"
};
const _hoisted_10 = {
  class: "name"
};
const _hoisted_11 = {
  class: "nr"
};
const _hoisted_12 = {
  style: {
    "white-space": "pre-wrap"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "口腔专家", -1))]), $setup.tjList.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
    class: "keshi",
    onClick: _cache[1] || (_cache[1] = $event => $setup.tjShow = !$setup.tjShow)
  }, [_createElementVNode("span", null, _toDisplayString($setup.tjList[$setup.tjList_index].dictLabel), 1), _cache[3] || (_cache[3] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/Polygon.png",
    alt: ""
  }, null, -1))])])) : _createCommentVNode("", true), $setup.tjShow ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tjList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: _normalizeStyle('color:' + ($setup.tjList_index == index ? '#41B9B2;' : '#000')),
      onClick: $event => $setup.tjListClick(index)
    }, _toDisplayString(item.dictLabel), 13, _hoisted_5);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "upList_dom",
      key: index
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
      src: item.imgUrl,
      alt: ""
    }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createElementVNode("h1", null, _toDisplayString(item.name), 1)]), _createElementVNode("span", null, _toDisplayString(item.label), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.intro), 1)])])]);
  }), 128))])]);
}